export default "__VITE_ASSET__B$7aQ4e5__"